export const NIGHTLIFE_TOUCHPOINT_CATEGORIES = [
    'Music',
    'Clubs & Parties',
    'Holiday',
    'Comedy & Shows',
    'Food & Drink',
    'Film & Media',
];
export const NIGHTLIFE_TOUCHPOINT_ID = 'touchpointCardDiv';

export const buttonData = [
    {
        link: 'comedy-and-shows',
        heapId: 'nightlife_touchpoint_comedy_and_shows_click',
        text: 'Comedy & Shows',
        statsigEvent: 'Listings - All - Click - Nightlife Touchpoint Comedy',
    },
    {
        link: 'clubs-and-parties',
        heapId: 'nightlife_touchpoint_clubs_and_parties_touchpoint_click',
        text: 'Clubs & Parties',
        statsigEvent: 'Listings - All - Click - Nightlife Touchpoint Parties',
    },
    {
        link: 'food-and-drink',
        heapId: 'nightlife_touchpoint_food_and_drink_touchpoint_click',
        text: 'Food & Drink',
        statsigEvent: 'Listings - All - Click - Nightlife Touchpoint Food',
    },
];
